<div class="otp-block" role="region" aria-labelledby="otp-block-caption">
  <ng-container *ngIf="showLeadText">
    <p class="otp-lead" *ngIf="maskedDestination">
      Escribe los <strong>{{ otpLength }} dígitos</strong> enviados a
      <strong class="otp-mail" translate="no">{{ maskedDestination }}</strong>.
      Se validará automáticamente al completarlos.
    </p>
    <p class="otp-lead" *ngIf="!maskedDestination">
      Escribe los <strong>{{ otpLength }} dígitos</strong> del código.
      Se validará automáticamente al completarlos.
    </p>
  </ng-container>

  <div class="otp-surface">
    <span class="otp-caption" id="otp-block-caption">Código de un solo uso</span>

    <fieldset class="otp-fieldset" [disabled]="expired || validating">
      <legend class="sr-only">{{ otpLength }} dígitos del código de verificación</legend>
      <div class="otp-digits-shell">
        <div class="otp-digits-row">
          <div class="otp-digits" role="group" aria-labelledby="otp-block-caption">
            <input
              *ngFor="let i of digitIndexes; trackBy: trackByIndex"
              #digitInput
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              autocomplete="one-time-code"
              class="otp-digit"
              [attr.aria-label]="'Dígito ' + (i + 1) + ' de ' + otpLength"
              (input)="onDigitInput(i, $event)"
              (keydown)="onDigitKeydown(i, $event)"
              (paste)="onDigitPaste(i, $event)" />
          </div>
          <button
            type="button"
            class="otp-ok"
            [disabled]="!canSubmit"
            (click)="onSubmit()"
            [attr.aria-label]="validating ? 'Validando código' : 'Validar código de verificación'">
            <i class="fas fa-spinner fa-spin" *ngIf="validating" aria-hidden="true"></i>
            <svg *ngIf="!validating" class="otp-ok__svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle class="otp-ok__ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
              <path class="otp-ok__mark" d="M7.75 12.1 10.45 14.8 16.35 8.65" stroke="currentColor" stroke-width="2.15" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </fieldset>

    <p class="otp-timer" *ngIf="remainingSeconds > 0" aria-live="polite">
      Nuevo código en <span class="otp-timer__value">{{ countdownLabel }}</span>
    </p>
    <p class="otp-timer otp-timer--ready" *ngIf="remainingSeconds <= 0 && showResendLink">
      Ya puedes pedir otro código.
    </p>
    <p class="otp-expired" *ngIf="expired && !showResendLink">{{ displayExpiredMessage }}</p>
  </div>

  <p class="otp-hint" *ngIf="hintText">{{ hintText }}</p>
  <p class="otp-hint" *ngIf="!hintText">¿No llega el correo? Revisa spam, promociones o “Todos los correos”.</p>

  <p class="error-msg" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

  <div class="otp-footer-actions">
    <button
      *ngIf="showCancelButton"
      type="button"
      class="btn btn-secondary"
      [disabled]="validating"
      [attr.aria-disabled]="validating"
      (click)="onCancel()">
      {{ cancelLabel }}
    </button>
    <button
      *ngIf="showResendLink"
      type="button"
      class="btn btn-secondary"
      [disabled]="!canResend || validating"
      (click)="onResend()">
      Reenviar código
    </button>
  </div>
</div>
